import {now} from 'moment';
import * as React from 'react';
import DatePicker from 'react-datepicker';
import {Alert as AlertComponent} from 'reactstrap';
import {CheckBox} from '../../../components/ui/CheckBox';
import {DataMultiBtnSelect} from '../../../components/ui/DataMultiBtnSelect';
import {TeamDropdown} from '../../../components/ui/FiltersBar/DataSources';
import {SelectUserDropdown} from './SelectUserDropdown';

interface IProps {
  dismissNewUserWarning: () => void
  handleInputChange: (event: any) => void
  refreshUsers: () => void
  updateDueDate: (date: Date) => void
  updateUserInput: (selectedUserID: number, newUser: boolean, newUserEmail?: string) => void
  updateActionAlertAvid: (avid: string[]) => void
  updateNoTeamCheckbox: () => void

  defaultHierarchyValue: string
  enabledInputs: string[];
  endStates: endState[];
  hierarchyValues: string[]
  inputActionTaken?: string;
  inputAssignee: number
  inputDescription: string
  inputDueDate: Date
  inputEndState: number;
  inputReason: number
  inputRootCause: number;
  inputSeverity: number;
  inputStatus: number
  isInactiveUser: boolean
  isValid: boolean
  newUserWarning: boolean
  noTeamCheckbox: boolean
  pristine: boolean
  reasons: Reason[]
  requiredInputs: string[]
  rootCauses: rootCause[];
  severityList: Severity[];
  statusTypes: Status[];
  users: User[],
}
export const FormEdit = (props: IProps) => {
  return (
    <form>
      <div className="d-flex">
        <div className="form-group only-edit">
          <label htmlFor="inputReason" className="">Reason</label>
          <select name="inputReason" className={(!props.isValid && props.inputReason === -1 ? 'custom-select is-invalid' : 'custom-select')} value={props.inputReason} onChange={
            props.handleInputChange}>
            {props.reasons.map((option, idx) => {
              return (
                <option value={option.id.toString()} key={'user' + idx}>{option.reason}</option>
              )
            })}
          </select>
          <div className="invalid-feedback">
            Please select a reason.
          </div>
        </div>
        <div className="form-group only-edit text-right">
          <label htmlFor="inputDueDate" className="" style={{ zIndex: 1, left: '40%' }}>Due Date</label>
          <DatePicker
            selected={props.inputDueDate}
            onChange={(date) => {
              props.updateDueDate(date)
            }}
            selectsStart
            startDate={now}
            popperPlacement="left"

          />
        </div>
      </div>
      <div className="d-flex">
        <div className="form-group">
          <label htmlFor="inputDescription" className="">Reason Detail</label>
          <textarea className={(!props.isValid && props.inputDescription.length === 0 ? 'form-control only-edit is-invalid' : 'form-control only-edit')} id="inputDescription" name="inputDescription" value={props.inputDescription} rows={1} onChange={
            props.handleInputChange}/>
          <div className="invalid-feedback">
            Please provide a description.
          </div>
        </div>
      </div>
      <div className="d-flex">
        <div className="form-group">
          <label htmlFor="inputAssignee" className="" style={{ left: '0' }}>Assignee</label>
          <div className="margin-bottom">
            <SelectUserDropdown
              id="inputAssignee"
              onChange={(selectedUserID, newUser, newUserEmail) =>
                props.updateUserInput(selectedUserID, newUser, newUserEmail)}
              userList={props.users.slice(1)}
              selectedUser={(props.inputAssignee ? props.inputAssignee : -1)}
              domainWhitelist={[]}
            />
          </div>
          <AlertComponent color="success" isOpen={props.newUserWarning} toggle={
            props.dismissNewUserWarning}>
            <p className="white-text strong">New User Added!</p>
          </AlertComponent>
          <AlertComponent color="warning" isOpen={props.isInactiveUser} toggle={
            props.dismissNewUserWarning}>
            You have selected an inactive user! <a href="#" className="alert-link" onClick={() =>
            props.refreshUsers()}>Refresh User List</a>
          </AlertComponent>
          <div className={'invalid-feedback text-danger' + ((!props.isValid && props.inputAssignee === -1 && !props.pristine) ? ' d-block' : '')}>
            Please select an assignee.
          </div>
        </div>
      </div>
      <div>
        <label htmlFor="inputAssignee" className=""
               style={{left: '0', fontWeight: 'bold', display: 'block'}}>Team</label>
        <div className="d-flex justify-content-between align-items-center">
          <div className="margin-bottom">
            <div className="border-input form-check-inline">
              {!props.noTeamCheckbox &&
              <DataMultiBtnSelect
                forceHTTPRequest
                  placeholder="Hierarchy"
                  source={TeamDropdown}
                  hidePopoverOnClear
                  hidePopoverOnLeadNodeSelect
                  useMobileMode={false}
                  persistLabel={true}
                  disableClearOnFirstSelect
                  showAllCoachingFormOption={false}
                  defaultValue={props.defaultHierarchyValue}
                  values={props.hierarchyValues}
                  onChange={(hierarchyValues) => {
                    props.updateActionAlertAvid(hierarchyValues)
                  }}
                  hideFirstSelectWhen={(source) => {
                    return source.length >= 1 && source[0].value && source[0].value.toLowerCase() === 'bankwide_0'
                  }}
              />
              }
              {props.noTeamCheckbox &&
              <div style={{padding: '0.375rem 0.75rem', paddingRight: 'calc(0.75rem + 21px)'}}
                   onClick={props.updateNoTeamCheckbox}>
                  <b className="fw-600">Hierarchy:</b> <span className="text-muted">Select a team</span><i
                  className="fas fa-fw fa-caret-down fa-lg fa-fw" style={{verticalAlign: 'initial'}}/>
              </div>
              }
            </div>
          </div>
          <div className="margin-bottom">
            <CheckBox onChange={props.updateNoTeamCheckbox} isEnabled isChecked={props.noTeamCheckbox}
                      label="No team / team not listed"/>
          </div>
        </div>
      </div>
      <div className="d-flex">
      </div>
      <div className="d-flex">
        <div className="form-group only-edit">
          <label htmlFor="inputStatus" className="">Status</label>
          <select name="inputStatus" className={(!props.isValid && props.inputStatus === -1 ? 'custom-select is-invalid' : 'custom-select')} value={props.inputStatus} onChange={
            props.handleInputChange}>
            {props.statusTypes.map((option, idx) => {
              return (
                <option value={option.id.toString()} key={'status' + idx}>{option.status}</option>
              )
            })}
          </select>
          <div className="invalid-feedback">
            Please select a state.
          </div>
        </div>
        <div className="form-group only-edit">
          <label htmlFor="inputSeverity" className="">Severity</label>
          <select name="inputSeverity" className="custom-select" value={props.inputSeverity} onChange={
            props.handleInputChange}>
            {props.severityList.map((option, idx) => {
              return (
                <option value={option.id.toString()} key={'severity' + idx}>{option.severity}</option>
              )
            })}
          </select>
        </div>
      </div>
      <div className="d-flex">
        <div className="form-group only-edit">
          <label htmlFor="inputActionTaken" className="">Action Taken</label>
          <textarea className={((!props.isValid && props.requiredInputs.includes('inputActionTaken')) && props.inputActionTaken.length === 0 ? 'form-control is-invalid' : 'form-control')} id="inputActionTaken" name="inputActionTaken" value={props.inputActionTaken} rows={5} onChange={
            props.handleInputChange}/>
          <div className="invalid-feedback">
            Please provide an action taken.
          </div>
        </div>
      </div>
      <div className="d-flex">
        {props.enabledInputs.includes('inputRootCause') &&
        <div className="form-group only-edit">
            <label htmlFor="inputRootCause" className="">Root Cause</label>
            <select name="inputRootCause" className={(!props.isValid && props.inputRootCause === -1 && props.requiredInputs.includes('inputRootCause') ? 'custom-select is-invalid' : 'custom-select')} value={props.inputRootCause} onChange={
              props.handleInputChange}>
              {props.rootCauses.map((option, idx) => {
                return (
                  <option value={option.id.toString()} key={'rootCause' + idx}>{option.rootCause}</option>
                )
              })}
            </select>
            <div className="invalid-feedback">
                Please select a root cause.
            </div>
        </div>
        }
        {props.enabledInputs.includes('inputEndState') &&
        <div className="form-group only-edit">
            <label htmlFor="inputEndState" className="">End State</label>
            <select name="inputEndState" className={(!props.isValid && props.inputEndState === -1 && props.requiredInputs.includes('inputEndState') ? 'custom-select is-invalid' : 'custom-select')} value={props.inputEndState} onChange={
              props.handleInputChange}>
              {props.endStates.map((option, idx) => {
                return (
                  <option value={option.id.toString()} key={'endState' + idx}>{option.endState}</option>
                )
              })}
            </select>
            <div className="invalid-feedback">
                Please select an end state.
            </div>
        </div>
        }
      </div>
    </form>
  );
};
